import { SiteLayout, PageBanner } from "../components/site/SiteLayout";
import { Services, Fleet } from "../components/site/Sections";
import { Industries, SignatureTruck } from "../components/site/Sections2";
import { usePrefs } from "../context/PrefsContext";

export default function Perkhidmatan() {
  const { t } = usePrefs();
  return (
    <SiteLayout>
      {(content) => (
        <div data-testid="perkhidmatan-page">
          <PageBanner title={t.nav.services} subtitle={t.banner.servicesSub} image={content.page_banners?.services?.image} video={content.page_banners?.services?.video} posY={content.page_banners?.services?.pos_y} />
          <SignatureTruck />
          <Services services={content.services} contact={content.contact} />
          <Fleet fleet={content.fleet} />
          <Industries industries={content.industries} />
        </div>
      )}
    </SiteLayout>
  );
}
